// src/views/components/TrustBadge/TrustBadge.jsx
import React, { memo } from 'react';
import '../components.css';

const TrustBadge = memo(({ icon: Icon, title, description }) => {
  return (
    <div className="trust-badge">
      <div className="trust-icon-wrap">
        <Icon size={24} />
      </div>
      <div className="trust-info">
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
    </div>
  );
});

export default TrustBadge;
